import React from 'react';
import { Modal, message, Form, Button, Input, InputNumber, Icon } from 'antd';
import moment from 'moment';
import { observable, action, runInAction, computed } from 'mobx';
import { observer } from 'mobx-react';
import {form_item_size} from '@common/theme';


import fetchUrl from '@service/fetchUrl';
import service from '@service/index';

class Store {
  constructor() {

  }
  init() {

  }

  /**
   * 控制 modal 是否显示
   */
  @observable
  is_modal_show = false;

  /**
   * 打开 modal 显示
   */
  @action
  openModal(record) {
    this.is_modal_show = true;
  }

  /**
   * 关闭 modal 显示
   */
  @action
  closeModal() {
    this.is_modal_show = false;
  }

  /**
   * 代充值
   */
  async submitCharge(params) {
    let result = await service.fetchData({
      path: fetchUrl.agent.payMoney,
      params: {
        username: params.username,
        money: params.money,
        pwd: params.pwd
      }
    });
    if ( result.success === true ) {
      return result;
    } else {
      return result;
    }
  }
}

let substitute_charge_store = new Store();

const FormItem = Form.Item;
window.moment = moment;
@Form.create()
@observer
class SubstituteChargeModal extends React.Component {
  constructor() {
    super();
  }

  formItemLayout = {
    labelCol: {
      xs: { span: 0 },
      sm: { span: 0 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 24 },
    },
  };

  @observable
  submitting = false;

  @observable
  password_input_type = 'password';

  @action
  togglePasswordInputType = () => {
    this.password_input_type = this.password_input_type === 'password' ? 'text' : 'password';
  };

  @action
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields( async (error, values) => {
      if(!error) {
        // console.log( values );
        let temp_value = {
          ...values
        };
        // console.log( temp_value );
        runInAction(() => {
          this.submitting = true;
        })
        let result = await substitute_charge_store.submitCharge(values);
        runInAction(() => {
          this.submitting = false;
        })
        if(result.success) {
          message.success(`为 ${values.username} 代充值 ${values.money} 成功！`, 3);
          // 重置编辑表单
          this.props.form.resetFields();
        } else {
          message.error(`为 ${values.username} 代充值 ${values.money} 失败！${ result.error.error_data }`, 3);
        }
        return;
      }
    })
  }

  render() {
    let { getFieldDecorator } = this.props.form;

    return (
      <Modal
        width='350px'
        visible={ substitute_charge_store.is_modal_show }
        // visible={ false }
        onCancel={() => {
          substitute_charge_store.closeModal();
        }}
        title={(
          <div>
            <span>代充</span>
          </div>
        )}
        footer={ null }>
        <Form>
          <FormItem
            {...this.formItemLayout}>
            {
              getFieldDecorator('username', {
                rules: [
                  {
                    required: true,
                    message: '请输入充值账号'
                  }
                ]
              })(
                <Input type="text" placeholder="请输入充值账号"/>
              )
            }
          </FormItem>
          <FormItem
            {...this.formItemLayout}>
            {
              getFieldDecorator('money', {
                rules: [
                  {
                    required: true,
                    message: '请输入代充金额'
                  }
                ]
              })(
                <InputNumber
                  placeholder='请输入代充金额'
                  style={{
                    width: '100%'
                  }}
                  min={ 0 }
                  step={ 1 }/>
              )
            }
          </FormItem>
          <FormItem
            {...this.formItemLayout}>
            {
              getFieldDecorator('pwd', {
                rules: [
                  {
                    required: true,
                    message: '请输入密码'
                  }
                ]
              })(
                <Input
                  placeholder='请输入支付密码'
                  size={ form_item_size }
                  type={ this.password_input_type }
                  addonAfter={
                    <Icon
                      size={form_item_size}
                      type="eye"
                      onClick={ this.togglePasswordInputType }/>
                  }
                />
              )
            }
          </FormItem>
          <FormItem
            {...this.formItemLayout}>
            <Button
              block
              type="primary"
              onClick={ this.handleSubmit }
              loading={ this.submitting }>
              充值
            </Button>
          </FormItem>
        </Form>
      </Modal>
    );
  }

  componentDidMount() {
  }
}

export {
  substitute_charge_store
}

export default SubstituteChargeModal;



// WEBPACK FOOTER //
// ./src/components/GlobalHeader/SubstituteChargeModal.jsx